import * as React from 'react';

export default function MyAppBar() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isSmall, setIsSmall] = React.useState(window.innerWidth <= 800);

  React.useEffect(() => {
    const handleResize = () => setIsSmall(window.innerWidth <= 800);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const links = [
    { label: 'Services', href: '#features' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: 'mailto:danielle@dckbookkeeping.com' },
  ];

  return (
    <nav className="nav-bar">
      <div className="nav-inner">
        <span className="nav-brand">DCK Bookkeeping Services Inc</span>
        {isSmall ? (
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '4px 8px',
              color: '#444',
            }}
          >
            {mobileOpen ? '\u2715' : '\u2630'}
          </button>
        ) : (
          <div className="nav-links">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="nav-link">{l.label}</a>
            ))}
          </div>
        )}
      </div>
      {isSmall && mobileOpen && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '4px',
          paddingBottom: '12px',
        }}>
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link"
              onClick={() => setMobileOpen(false)}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
